import { BookOpen, Lightbulb } from "lucide-react";
import { PageHero, SectionHead, Reveal } from "@/components/site/Section";
import { FaqList } from "@/pages/site/Home";
import { IMG } from "@/data/content";

const GUIDES = [
  { t: "Building a brand voice your AI can follow", d: "Define tone, audience, key messages and terms to avoid so every draft sounds like you.", img: IMG.founders, tag: "Brand" },
  { t: "Planning a two-week content calendar", d: "Balance educational, promotional and community posts across channels without burning out.", img: IMG.dashboard, tag: "Planning" },
  { t: "SEO basics for small business blogs", d: "Pick realistic keywords, match search intent, and structure articles readers finish.", img: IMG.laptop, tag: "SEO" },
  { t: "Preparing your first paid social campaign", d: "Objectives, audiences, budgets and creative briefs — before you spend a rupee.", img: IMG.social, tag: "Ads" },
];
const TIPS = [
  "Feed the Knowledge Base with approved facts — AI is only as accurate as its sources.",
  "Always review drafts for claims, prices and dates before approving.",
  "Repurpose one blog into 4–6 social posts for consistency.",
  "Use Gemini 3 Flash for quick ideas and Claude Sonnet 4.5 for long-form polish.",
  "Measure weekly, change one thing at a time, and keep what works.",
  "Never promise outcomes in ads — focus on clear value and proof you can stand behind.",
];

export default function Resources() {
  return (
    <div data-testid="resources-page">
      <PageHero eyebrow="Resources" title={<>Marketing guides, <span className="text-gradient">AI tips & answers</span></>}
        copy="Practical, no-hype advice for small teams using AI in their marketing." />
      <section id="guides" className="py-20 scroll-mt-20">
        <div className="container-x">
          <SectionHead eyebrow="Marketing guides" title="Guides" />
          <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
            {GUIDES.map((g, i) => (
              <Reveal key={g.t} delay={i * 0.05}>
                <article className="card-box overflow-hidden lift h-full" data-testid={`guide-card-${i}`}>
                  <img src={g.img} alt="" className="h-40 w-full object-cover" />
                  <div className="p-6">
                    <span className="font-mono text-[10px] uppercase tracking-widest text-[#db2777]">{g.tag}</span>
                    <h3 className="mt-2 font-semibold leading-snug flex gap-2"><BookOpen className="h-4 w-4 mt-1 shrink-0 text-[#7c3aed]" />{g.t}</h3>
                    <p className="mt-2 text-sm text-muted-foreground">{g.d}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <section id="tips" className="py-20 border-t bg-card/40 scroll-mt-20">
        <div className="container-x">
          <SectionHead eyebrow="AI marketing tips" title="Quick wins" />
          <div className="mt-10 grid gap-4 md:grid-cols-3">
            {TIPS.map((t, i) => (
              <div key={t} className="rounded-2xl border bg-card p-6 flex gap-4"><Lightbulb className="h-5 w-5 shrink-0 text-[#f59e0b]" /><p className="text-sm">{t}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section id="faqs" className="py-20 border-t scroll-mt-20">
        <div className="container-x grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4"><SectionHead eyebrow="FAQs" title="Frequently Asked Questions" /></div>
          <div className="lg:col-span-8"><FaqList /></div>
        </div>
      </section>
    </div>
  );
}
